import styled from 'styled-components';
import { Button } from 'evergreen-ui';

export const CustomButton = styled(Button)`
  :disabled {
    background-color: #644839;
  }
`;

export const StyledLink = styled.a`
  color: #d7dce9;
  font-weight: bold;
  :visited {
    color: #d7dce9;
  }
`;
